/* Clocked Out PC — global behaviour
   Progressive enhancement only: every feature here has a working
   no-JS fallback (native details/summary, normal links, plain forms). */
(function () {
  'use strict';

  var COP = window.COP = window.COP || {};

  /* ---------- Money formatting ---------- */
  COP.formatMoney = function (cents) {
    var format = COP.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = withCommas + '.' + parts[1];
    var noDecimals = withCommas;
    return format
      .replace(/\{\{\s*amount\s*\}\}/, out)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, out.replace(/,/g, ' ').replace('.', ','))
      .replace(/<[^>]*>/g, '');
  };

  /* ---------- Toast ---------- */
  var toastTimer;
  COP.toast = function (message, opts) {
    opts = opts || {};
    var el = document.getElementById('Toast');
    var msg = document.getElementById('ToastMessage');
    var action = document.getElementById('ToastAction');
    if (!el || !msg) return;
    msg.textContent = message;
    if (action) {
      if (opts.actionHref) {
        action.href = opts.actionHref;
        action.textContent = opts.actionLabel || 'View';
        action.hidden = false;
      } else {
        action.hidden = true;
      }
    }
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, opts.duration || 4500);
  };

  /* ---------- Cart count ---------- */
  COP.setCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', String(count));
    });
  };
  COP.refreshCartCount = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { COP.setCartCount(cart.item_count); })
      .catch(function () { /* non-fatal */ });
  };

  /* ---------- Header dropdowns (desktop) ---------- */
  var dropdowns = Array.prototype.slice.call(document.querySelectorAll('[data-dropdown]'));
  function closeDropdowns(except) {
    dropdowns.forEach(function (dd) {
      if (dd === except) return;
      var btn = dd.querySelector('[data-dropdown-toggle]');
      var panel = dd.querySelector('[data-dropdown-panel]');
      if (btn && panel) {
        btn.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
      }
    });
  }
  dropdowns.forEach(function (dd) {
    var btn = dd.querySelector('[data-dropdown-toggle]');
    var panel = dd.querySelector('[data-dropdown-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeDropdowns(dd);
      btn.setAttribute('aria-expanded', String(!open));
      panel.classList.toggle('is-open', !open);
    });
    dd.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        btn.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
        btn.focus();
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dropdown]')) closeDropdowns(null);
  });

  /* ---------- Mobile drawer ---------- */
  var drawer = document.getElementById('MobileDrawer');
  var drawerOpenBtn = document.querySelector('[data-drawer-open]');
  if (drawer && drawerOpenBtn) {
    var supportsDialog = typeof drawer.showModal === 'function';
    drawerOpenBtn.addEventListener('click', function () {
      if (supportsDialog) {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
      drawerOpenBtn.setAttribute('aria-expanded', 'true');
      var closeBtn = drawer.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.focus();
    });
    function closeDrawer() {
      if (supportsDialog) {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
      drawerOpenBtn.setAttribute('aria-expanded', 'false');
      drawerOpenBtn.focus();
    }
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer(); // backdrop click
      if (e.target.closest('[data-drawer-close]')) closeDrawer();
    });
    drawer.addEventListener('cancel', function () {
      drawerOpenBtn.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Sticky mobile buy bar (product pages) ---------- */
  var stickyBuy = document.querySelector('[data-sticky-buy]');
  var buySentinel = document.querySelector('[data-buy-sentinel]');
  if (stickyBuy && buySentinel && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBuy.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    sio.observe(buySentinel);
  }

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        var img = main.querySelector('img');
        if (img && full) {
          img.src = full;
          img.removeAttribute('srcset');
          img.alt = alt;
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    COP.refreshCartCount();
  });
})();


/* ==========================================================
   Sticky header - keep pinned on scroll down, hide on scroll up
   Pairs with the .header-sticky rules in assets/base.css
   ========================================================== */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var wrap = header.parentElement;
  wrap.classList.add('header-sticky');

  var lastY = window.scrollY;
  var ticking = false;
  var DELTA = 8;
  var REVEAL_AT = 120;

  function update() {
    ticking = false;
    var y = window.scrollY;
    var diff = y - lastY;

    if (document.querySelector('.mobile-drawer[open]')) {
      wrap.classList.remove('is-hidden');
      lastY = y;
      return;
    }
    if (y <= REVEAL_AT) {
      wrap.classList.remove('is-hidden');
      lastY = y;
      return;
    }
    if (Math.abs(diff) < DELTA) return;

    wrap.classList.toggle('is-hidden', diff < 0);
    lastY = y;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
})();


/* ==========================================================
   Dark mode toggle
   Injects a pill toggle into the header actions and remembers
   the choice in localStorage['cop-theme'].
   Pairs with the [data-theme="dark"] rules in assets/base.css
   ========================================================== */
(function () {
  var KEY = 'cop-theme';
  var root = document.documentElement;

  function stored() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }

  function preferred() {
    return stored() || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  }

  function apply(theme, persist) {
    root.setAttribute('data-theme', theme);
    var dark = theme === 'dark';
    document.querySelectorAll('.theme-toggle').forEach(function (b) {
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      b.setAttribute('title', dark ? 'Switch to light mode' : 'Switch to dark mode');
    });
    if (persist) { try { localStorage.setItem(KEY, theme); } catch (e) {} }
  }

  var SUN = '<svg class="tt-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.2 5.2l1.4 1.4M17.4 17.4l1.4 1.4M18.8 5.2l-1.4 1.4M6.6 17.4l-1.4 1.4"/></svg>';
  var MOON = '<svg class="tt-moon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z"/></svg>';

  function build() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'theme-toggle';
    btn.setAttribute('aria-label', 'Toggle dark mode');
    btn.innerHTML = '<span class="theme-toggle__knob">' + SUN + MOON + '</span>';
    btn.addEventListener('click', function () {
      apply(root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark', true);
    });
    return btn;
  }

  function mount() {
    var actions = document.querySelector('.site-header__actions');
    if (actions && !actions.querySelector('.theme-toggle')) {
      var menu = actions.querySelector('.menu-toggle');
      if (menu) { actions.insertBefore(build(), menu); } else { actions.appendChild(build()); }
    }
    apply(preferred(), false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY && e.newValue) { apply(e.newValue, false); }
  });
})();
